import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { SidebarProvider } from "hooks/useSidebar";
import { ClientConfigProvider } from "hooks/useClientConfig";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ClientConnectionStatusProvider } from "hooks/useClientConnectionStatus";

interface IProps {
  children: React.ReactNode;
}

const ConfigQueryClient = ({ children }: IProps) => {
  const navigate = useNavigate();

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: Infinity,
        cacheTime: Infinity,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
        retry: 1,
        onError: ({ response }) => {
          if (
            response?.status === 503 &&
            response?.data?.message === "IN_MAINTENANCE"
          )
            navigate("/under-maintenance");
        },
      },
    },
  });
  return (
    <QueryClientProvider client={queryClient}>
      <ClientConnectionStatusProvider>
        <SidebarProvider>
          <ClientConfigProvider>{children}</ClientConfigProvider>
        </SidebarProvider>
      </ClientConnectionStatusProvider>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        stacked
      />
    </QueryClientProvider>
  );
};

export default ConfigQueryClient;
